module.exports = __webpack_public_path__ + "thebookingbutton-src-icon.png?c9afe6d086afade822698412400b5aa3";